export default function VideoDiagnosisSection() {
  return (
    <section className="py-10 md:py-20 bg-gradient-to-br from-background-50 via-primary-50/15 to-accent-50/20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-12 items-center">
          <div className="flex-1 w-full">
            <p className="text-xs md:text-sm text-primary-600 font-medium mb-2 uppercase tracking-wider">
              Una innovación de Persianas Málaga
            </p>
            <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3 md:mb-4 leading-tight font-heading">
              Diagnóstico por Videollamada — GRATIS
            </h2>
            <p className="text-sm md:text-base text-foreground-700 mb-4 md:mb-6 leading-relaxed">
              ¿No sabes qué le pasa a tu persiana o mosquitera? Haznos una videollamada por WhatsApp y nuestro técnico diagnosticará la avería al instante, sin necesidad de desplazamiento y sin compromiso. Te decimos qué tiene y te damos presupuesto cerrado en minutos. Disponible en todos los barrios de Málaga.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 mb-6 md:mb-8">
              <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line text-primary-600 text-sm"></i></span>
                </div>
                <span className="text-sm font-medium text-foreground-800">Sin desplazamiento</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line text-primary-600 text-sm"></i></span>
                </div>
                <span className="text-sm font-medium text-foreground-800">Respuesta inmediata</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line text-primary-600 text-sm"></i></span>
                </div>
                <span className="text-sm font-medium text-foreground-800">Presupuesto al momento</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500/15 flex-shrink-0">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line text-accent-600 text-sm"></i></span>
                </div>
                <span className="text-sm font-medium text-foreground-800">Totalmente gratis</span>
              </div>
            </div>
            <a
              href="https://wa.me/34627213347?text=Hola%2C%20quiero%20un%20diagn%C3%B3stico%20por%20videollamada"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-semibold text-sm md:text-base px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              Pedir diagnóstico por WhatsApp
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill text-lg"></i></span>
            </a>
          </div>
          <div className="w-full lg:w-[45%] h-56 sm:h-72 md:h-96 rounded-2xl overflow-hidden flex-shrink-0">
            <img
              alt="Móvil mostrando una videollamada de diagnóstico con un técnico de Persianas Málaga"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              src="/images/016-diagnostico-videollamada-malaga-v2.webp"
            />
          </div>
        </div>
      </div>
    </section>
  );
}